import { ThemeProvider } from '@mui/material';

import NoApplicationScreen from '../components/noApplicationScreen';

import appThemeV2 from 'theme/themeV2';

const NoApplicationPage = () => {
    return (
        <ThemeProvider theme={appThemeV2}>
            <NoApplicationScreen maxWidth="sm" />
        </ThemeProvider>
    );
};

export default NoApplicationPage;
